import { RootState } from '../../rootReducer'

export const selectedProfessional = (state: RootState) => state.profile.professional
export const modalCropImageVisible = (state: RootState) => state.profile.isVisible
export const modalCropImageData = (state: RootState) => state.profile.modalCropImageData
